import { sectionContainerAtom } from '@ingenico/react-section-utils';
import { getDefaultStore } from 'jotai';
import type { ReactElement } from 'react';
import { Outlet } from 'react-router';
import { deviceManagementContainer } from './container.const';

const sectionStore = getDefaultStore();

export function EntryComponent(): ReactElement {
  // Publish this section's DI container before its pages render — pages read
  // sectionContainerAtom synchronously (useSectionContainer throws if null).
  // Doing it here (the section layout's render), guarded against redundant writes,
  // is cold-mount safe and only swaps when this section becomes active — so it
  // never leaks into another section's page mid-navigation (a routes-builder /
  // patchRoutesOnNavigation-time set did, briefly flashing the error boundary).
  if (sectionStore.get(sectionContainerAtom) !== deviceManagementContainer) {
    sectionStore.set(sectionContainerAtom, deviceManagementContainer);
  }

  return <Outlet />;
}
